<template>
  <div id="pageCard">
    <v-container grid-list-xl fluid>

      <v-layout row wrap>
        <v-flex lg6 sm6 xs6>
          <img src="static/FAO.png"  width="60%">
        </v-flex>
        <v-flex lg6 sm6 xs6>
          <img src="static/logo.png" align="right"  width="50%">
        </v-flex>
        <v-flex lg12 sm12 xs12>
       <h2 class=" grey--text text--darken-1" style="text-align: center;"> تكوين قاعدة  بيانات للنساء جامعات المحار برؤية<br>أوضح لدعم قدراتهن وتحسين ظروفهن الاقتصادية</h2>
        </v-flex>

        <v-flex lg12 sm12 xs12>
          <h3 class="text--darken-1 " style="text-align: right; color: #00838F ">ورشة الإنطلاق</h3>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg1/a.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg1/b.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg1/c.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg1/d.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg1/e.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg1/f.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
<!------------------------------------------------------------------->
        <v-flex lg12 sm12 xs12>
          <h3 class="text--darken-1 " style="text-align: right; color: #00838F ">تدريب على تقنيات الإحصاء</h3>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg2/a.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg2/b.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg2/c.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <!------------------------------------------------------------------->
        <v-flex lg12 sm12 xs12>
          <h3 class="text--darken-1 " style="text-align: right; color: #00838F ">اجتماع اللجنة التوجيهية </h3>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg3/a.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg3/b.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg3/c.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <!------------------------------------------------------------------->
        <v-flex lg12 sm12 xs12>
          <h3 class="text--darken-1 " style="text-align: right; color: #00838F ">زيارة ميدانية لجزيرة جربة</h3>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg4/a.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg4/b.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg4/c.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <!------------------------------------------------------------------->
        <v-flex lg12 sm12 xs12>
          <h3 class="text--darken-1 " style="text-align: right; color: #00838F ">زيارة ميدانية لولاية صفاقس معتمدية زبوسة</h3>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg5/a.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg5/b.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg5/c.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <!------------------------------------------------------------------->
        <v-flex lg12 sm12 xs12>
          <h3 class="text--darken-1 " style="text-align: right; color: #00838F ">زيارة ميدانية لولاية قابس</h3>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg6/a.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg6/b.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
        <v-flex lg4 sm12 xs12>
          <v-card>
            <v-card-media src="static/bg6/c.JPG" height="250">
            </v-card-media>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
export default {
  components: {
    VWidget
  },
  data () {
    return {
      show: true,
      cardText: 'Hey there, I am a very simple card. I am good at containing small bits of information. I am quite convenient because I require little markup to use effectively.'
    };
  },
  computed: {
  },  
  methods: {
  }
};
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/accueil.vue